import axios from 'axios'
import type { orderInterface } from '@/stores/orders'

export interface WorkingTimeConfirmation {
    cancel_conflicts: true
    conflict_token: string
    reason: string
}
export class WorkingTimeConflictError extends Error {
    constructor(public readonly conflicts: orderInterface[], public readonly token: string) {
        super('Working time conflicts require confirmation.')
        this.name = 'WorkingTimeConflictError'
    }
}
export function workingTimeError(error: unknown): Error {
    if (axios.isAxiosError(error)) {
        const data = error.response?.data
        if (error.response?.status === 409 && data?.code === 'working_time_conflict' && Array.isArray(data.conflicts)
            && typeof data.conflict_token === 'string' && /^[a-f0-9]{64}$/.test(data.conflict_token)) {
            return new WorkingTimeConflictError(data.conflicts, data.conflict_token)
        }
        return new Error(data?.message || error.message || 'An error occurred')
    }
    return error instanceof Error ? error : new Error('An error occurred')
}
